import { MeasureUnitTable } from "../../../../../../../../../api/types/svTypes.ts";
import type { DrillDownConfiguration } from "../../../../../../../../../api/types/svTypes.ts";
import type { LedgerBucket } from "./drillDownLedgerColumnsStorage";

/**
 * Ledgers that extend the General Ledger row-for-row (they share its Entry No.) rather than
 * standing beside it. They get their own drill-down grid instead of the GL/Memo tab view,
 * and their rows are terminal — there is nothing further to drill into.
 */
export interface ExtensionLedger {
  dataModelName: string;
  /** Ledger whose rows these extend — its dimensions resolve on an extension row too. */
  extendsDataModelName: string;
  bucket: LedgerBucket;
  tabTitle: string;
  pageTitle: string;
  getConfiguration: (configuration: DrillDownConfiguration) => DrillDownConfiguration | undefined;
}

const extensionLedgers = new Map<MeasureUnitTable, ExtensionLedger>([
  [
    MeasureUnitTable.ApAr,
    {
      dataModelName: "DetailedApArLedger",
      extendsDataModelName: "GeneralLedger",
      bucket: "apar",
      tabTitle: "AP/AR Detailed Ledger",
      pageTitle: "AP/AR Ledger",
      getConfiguration: (configuration) => configuration.apArConfiguration,
    },
  ],
  [
    MeasureUnitTable.Vat,
    {
      dataModelName: "VatLedger",
      extendsDataModelName: "GeneralLedger",
      bucket: "vat",
      tabTitle: "VAT Ledger",
      pageTitle: "VAT Ledger",
      getConfiguration: (configuration) => configuration.vatConfiguration,
    },
  ],
]);

export const getExtensionLedger = (table: MeasureUnitTable | undefined): ExtensionLedger | undefined => {
  return table === undefined ? undefined : extensionLedgers.get(table);
};

export const getExtensionLedgerByDataModelName = (dataModelName: string): ExtensionLedger | undefined => {
  return [...extensionLedgers.values()].find((ledger) => ledger.dataModelName === dataModelName);
};

export const extensionLedgerDataModelNames: readonly string[] = [...extensionLedgers.values()].map(
  (ledger) => ledger.dataModelName
);
